export class ZipCityAutocompletionRequestModel {
  countryCode: string;
  postalCode: string;
  placeName: string;
}
